// extracted by mini-css-extract-plugin
export var box = "styles-module--box--29HAt";
export var langItem = "styles-module--langItem--3Hsnb";